export default __webpack_public_path__ + "static/media/img_baseBunny_lemon.697a57d3.jpg";